export default (
  timeSeriesCollection: number[][][]
): { dateKey: number; data: number[] }[] => {
  if (!timeSeriesCollection || timeSeriesCollection.length === 0) return [];

  return timeSeriesCollection[0].map((timeSeries) => {
    const data: { dateKey: number; data: number[] } = {
      dateKey: timeSeries[0],
      data: [],
    };

    //Add the measurement from each time series
    timeSeriesCollection.forEach((series) => {
      //Get the corresponding date values
      const row = series.filter((x) => x.length > 1 && x[0] === data.dateKey);

      const measurement =
        row && row.length > 0 && row[0].length > 1 ? row[0][1] : 0;

      data.data.push(measurement);
    });

    return data;
  });
};

export function seriesArraySortDesending(
  first: { dateKey: number; data: number[] },
  second: { dateKey: number; data: number[] }
) {
  if (first.dateKey < second.dateKey) return 1;
  else if (first.dateKey > second.dateKey) return -1;
  else return 0;
}

export function seriesArraySortAsending(
  first: { dateKey: number; data: number[] },
  second: { dateKey: number; data: number[] }
) {
  if (first.dateKey > second.dateKey) return -1;
  else if (first.dateKey < second.dateKey) return 1;
  else return 0;
}
